// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import bgImage from 'assets/images/background.png';

type Props = {
  name: string
}

const Header = (props: Props) => {
  const { t } = useTranslation();

  const { name } = props;

  if (!name) {
    return null;
  }

  return (
    <>
      <section className="heading-section profile-heading-section goal-details-heading" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="container">
          <div className="profile-heading-section-name">
            {`${name} ${t('public_goal_header_is_saving_for_title')}` }
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
